import React, { useState } from 'react';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import {
  WebsitesContainer,
  WebsitesFormContainer,
  WebsitesCodeContainer,
} from './websites';
import { Layout, Modal } from 'antd';
import { StatisticsContainer } from './statistics';
import { AdminHeader, ChangePasswordForm } from './shared';
import { useSessionFacade } from './auth/store/hooks';

const { Content } = Layout;

const AdminContainer: React.FC<RouteComponentProps> = () => {
  const facade = useSessionFacade();
  const [isModalOpened, setModalOpened] = useState(false);

  const handleLogout = () => {
    facade.logout();
  };

  const handlePasswordChange = async (
    currentPassword: string,
    newPassword: string
  ) => {
    const res = await facade.changePassword(currentPassword, newPassword);

    if (res.response) {
      setModalOpened(false);
    }
  };

  const handleModalOpen = () => {
    setModalOpened(true);
  };

  const handleModalClose = () => {
    setModalOpened(false);
  };

  const renderChangePasswordModal = () => {
    if (!isModalOpened) {
      return null;
    }

    return (
      <Modal
        title={'Update password'}
        width={460}
        destroyOnClose={true}
        visible={true}
        footer={null}
        onCancel={handleModalClose}
      >
        <ChangePasswordForm onSubmit={handlePasswordChange} />
      </Modal>
    );
  };

  return (
    <Layout className="admin-layout">
      <AdminHeader onChangePassword={handleModalOpen} onLogout={handleLogout} />
      <Content>
        <Route
          path="/admin"
          exact={true}
          render={() => <Redirect to="/admin/websites" />}
        />
        <Route path="/admin/websites" component={WebsitesContainer} />
        <Route
          path="/admin/websites/create"
          exact={true}
          component={WebsitesFormContainer}
        />
        <Route
          path="/admin/websites/edit/:id"
          exact={true}
          component={WebsitesFormContainer}
        />
        <Route
          path="/admin/websites/code/:id"
          exact={true}
          component={WebsitesCodeContainer}
        />
        <Route
          path="/admin/stats/:id"
          exact={true}
          component={StatisticsContainer}
        />
        {renderChangePasswordModal()}
      </Content>
    </Layout>
  );
};

export default AdminContainer;
